export const DESKTOP_L = 'lg'
export const DESKTOP_S = 'md'
export const TABLET = 'sm'
export const MOBILE = 'xs'

export const GOOGLE_PLAY_URL =
	'https://play.google.com/store/apps/details?id=com.suremobility.tagoga'
export const APPLE_STORE_URL =
	'https://apps.apple.com/kr/app/%ED%83%80%EA%B3%A0%EA%B0%80/id1548401770'
export const INSTARGRAM_URL =
	'https://www.instagram.com/tagoga_official/'
